module.exports = __webpack_public_path__ + "img/arrow-left-to-line.bc2eaa78.svg";